/* Live operations feed — the rotating status line and its "LIVE OPS" label.
 *
 * Extracted from Header.jsx when the strip moved to the dashboard's hero
 * panel, so the copy has one home rather than being duplicated at each
 * render site.
 *
 * Every line describes simulated state. Nothing here is observed, and the
 * panel that renders it carries the SIMULATED badge alongside. */

export const LIVE_OPS_LABEL = { en: "LIVE OPS", mr: "थेट कार्यरत" };
export const FEED_LABEL = { en: "Feed", mr: "फीड" };

export const TICKER = [
  { en: "LIVE · Ramkund Ghat 92% crowd density — active monitoring",
    mr: "थेट · रामकुंड घाट 92% गर्दी घनता — सक्रिय निरीक्षण" },
  { en: "LIVE · 6,84,210 pilgrims active across Nashik & Trimbakeshwar",
    mr: "थेट · नाशिक व त्र्यंबकेश्वरमध्ये 6,84,210 यात्रेकरू सक्रिय" },
  { en: "ALERT · Water Station 8 Panchvati at 91% capacity",
    mr: "सूचना · पंचवटी येथे जल केंद्र 8, 91% क्षमतेवर" },
  { en: "UPDATE · MSRTC shuttle SR-04 delayed 22 min — alternate routes active",
    mr: "अद्यतन · एमएसआरटीसी शटल SR-04, 22 मिनिटे विलंबित — पर्यायी मार्ग सक्रिय" },
  { en: "INFO · AI Assurance layer running at 93.7% confidence",
    mr: "माहिती · एआय हमी स्तर 93.7% विश्वासार्हतेने कार्यरत" },
  { en: "SAFE · Missing person MP-1182 reunited with family",
    mr: "सुरक्षित · हरवलेली व्यक्ती MP-1182 कुटुंबाला भेटली" },
  { en: "WEATHER · Nashik 38°C — Heat advisory in effect for all zones",
    mr: "हवामान · नाशिक 38°C — सर्व झोनसाठी उष्णतेचा इशारा लागू" },
];

export const TICKER_INTERVAL_MS = 5000;
